/**
 * Dashboard Service - Irrigo Platform
 * Servicio para estadísticas y actividad del dashboard
 */

import { api, ApiResponse } from './api';
import type { ApiDashboardStats, ApiDashboardActivity } from '@/types/api';

// ============================================================================
// DASHBOARD SERVICE
// ============================================================================

export const dashboardService = {
  /**
   * Obtener estadísticas del dashboard
   */
  async getStats(): Promise<ApiResponse<ApiDashboardStats>> {
    return api.get<ApiDashboardStats>('/dashboard/stats');
  },

  /**
   * Obtener actividad reciente
   */
  async getActivity(limit: number = 10): Promise<ApiResponse<ApiDashboardActivity>> {
    return api.get<ApiDashboardActivity>('/dashboard/activity', { limit });
  },
};

export default dashboardService;
